import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SpecializationListComponent } from './specialization-list/specialization-list.component';
import { SpecializationCreateComponent } from './specialization-create/specialization-create.component';


const routes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'list',
        component: SpecializationListComponent,
        data: {
          title: "Specialization List",
          breadcrumb: "Specialization List"
        }
      },
      {
        path: 'create',
        component: SpecializationCreateComponent,
        data: {
          title: "Create Specialization",
          breadcrumb: "Create Specialization"
        }
      },
      {
        path: 'edit/:id',
        component: SpecializationCreateComponent,
        data: {
          title: "Edit Specialization",
          breadcrumb: "Edit Specialization"
        }
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})

export class SpecializationRoutingModule { }
